import React from 'react';
import { Loader2 } from 'lucide-react';
import { usePurchaseOrderCsvUpload } from '../usePurchaseOrderCsvUpload';

const ProcessingStep: React.FC = () => {
  const { processing } = usePurchaseOrderCsvUpload();

  return (
    <div className="flex flex-col items-center justify-center py-10 gap-6">
      <Loader2 className="h-8 w-8 animate-spin text-threadheads-purple" />

      <div className="w-full max-w-sm space-y-2">
        <div className="relative h-3 w-full overflow-hidden rounded-full bg-secondary">
          <div
            className="absolute h-full w-1/3 rounded-full bg-threadheads-purple/60"
            style={{
              animation: 'po-indeterminate 1.5s ease-in-out infinite',
            }}
          />
        </div>
        <p className="text-sm text-center text-muted-foreground">
          Applying {processing.total} item{processing.total !== 1 ? 's' : ''}...
        </p>
      </div>

      <style>{`
        @keyframes po-indeterminate {
          0%   { left: -33%; width: 33%; }
          50%  { left: 33%;  width: 33%; }
          100% { left: 100%; width: 33%; }
        }
      `}</style>
    </div>
  );
};

export default ProcessingStep;
